const getUnnormalizedCategory = (normalizedCategory: string) => {
  if (!normalizedCategory) {
    return '';
  }

  if (typeof window === 'undefined' || !window.decodeURIComponent) {
    return normalizedCategory;
  }

  return window.decodeURIComponent(normalizedCategory);
};

export default getUnnormalizedCategory;
